
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const SearchBar = () => {
  return (
    <div className="relative w-80">
      <div className="flex items-center border rounded-md bg-white/5 backdrop-blur-sm focus-within:ring-2 focus-within:ring-purple-500 focus-within:border-purple-500 transition-all">
        <Search className="ml-3 h-4 w-4 text-muted-foreground" />
        <Input 
          placeholder="Search agents..." 
          className={cn(
            "pl-2 h-9 bg-transparent border-0",
            "placeholder:text-muted-foreground/70",
            "focus-visible:ring-0 focus-visible:ring-offset-0"
          )}
        />
      </div>
    </div>
  );
};

export default SearchBar;
